<template>
    <cart-summary class="cart-summary">
        <h3>
            {{ title_summary }}
        </h3>

        <template v-if="show_shipping_calculation">
            <template v-for="collapse in collapses">
                <div :key="collapse.id" v-if="hasSlot(collapse.id)">
                    <h4>
                        <a
                            data-toggle="collapse"
                            :href="'#' + collapse.id"
                            :class="[collapse.collapsed ? null : 'collapsed']"
                            role="button"
                            aria-expanded="false"
                            :aria-controls="collapse.id"
                        >
                            {{ collapse.title }}
                        </a>
                    </h4>

                    <div
                        class="collapse"
                        :class="[collapse.collapsed ? 'show' : null]"
                        :id="collapse.id"
                    >
                        <slot :name="collapse.id"></slot>
                    </div>
                </div>
            </template>
        </template>
        <slot name="footer"></slot>
    </cart-summary>
</template>

<script>
import { mapGetters } from "vuex";
import { CCartSummary } from "./Styles/Template/styled";

export default {
    name: "Summary",
    components: {
        "cart-summary": CCartSummary
    },
    props: {
        title_summary: {
            required: true,
            type: String
        },
        title_collapse: {
            default: ""
        },
        collapses: {
            required: true
        }
    },
    methods: {
        hasSlot(slot) {
            return !!this.$slots[slot];
        }
    },
    computed: {
        ...mapGetters("company", ["getShowShippingCalculation"]),
        show_shipping_calculation() {
            return (
                (this.title_collapse == "Calcular frete" &&
                    this.getShowShippingCalculation) ||
                this.title_collapse != "Calcular frete"
            );
        }
    }
};
</script>
